class s extends Error{constructor(s){const{variables:r,message:e}=s;super(e),this.variables=r}}export{s as ClientValidationError};